import {ModalController, NavParams} from '@ionic/angular';
import { Component, OnInit, ViewChild  } from '@angular/core';
import { Chart } from 'chart.js';
import { Router} from '@angular/router';
import{ApiService} from '../../../services/api.service';

@Component({
  selector: 'app-member-parent',
  templateUrl: './member-parent.page.html',
  styleUrls: ['./member-parent.page.scss'],
})
export class MemberParentPage{
	imageUrl: string = 'assets/imgs/parent-bg.jpg';
  constructor(private api:ApiService, private router:Router) {
     
  }  
  ionViewDidEnter(){
    this.api.isLoggedIn();
    this.getStudentData();
  }

  studentData:any={};
  getStudentData()
  {
    this.api.data('user/me','get','').subscribe(data=>{
        this.studentData=data;
    },error=>{
        this.router.navigate(['/page/tabs/tab2']);
    })
  }

}
